import { Middleware } from "@reduxjs/toolkit"
import { setErrorMessage } from "../store/slices/commonSlice"
import { shouldShowGlobalError } from "./errorConfig"

export const globalErrorMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    if (action.type?.endsWith("/rejected")) {
      const error = action.payload || action.error

      const enhancedError = {
        ...error,
        endpointName: action.type?.split("/")[0] || "",
        type: action.type
      }

      if (shouldShowGlobalError(enhancedError)) {
        store.dispatch(
          setErrorMessage({
            status: error?.status || error?.originalStatus || 0,
            code: error?.code || 0,
            message: error?.data?.message || error?.message || "Server error",
            data: error?.config?.data,
            url: error?.request?.responseURL,
            serverMessage: error?.response?.data
              ? JSON.stringify(error.response.data)
              : ""
          })
        )
      }
    }

    return next(action)
  }
